<template>
    <v-card color="grey lighten-2" :loading="loading" :disabled="loading">
        <v-card-text>
          <v-list color="grey lighten-2">
              <set-role-form-item v-for="(contact, key) in contacts" :key="key" :event="event" :contact="contact" @onUnsetResolver="unsetResolver" @onConfirm="setAsResolver"></set-role-form-item>
              <v-divider></v-divider>
          </v-list>
        </v-card-text>
        <contact-form v-bind="contact" @onClose="close" :dark="false" :set-contact-type-id="RESOLVER_CONTACT_TYPE_ID" :header="false" :event-id="eventId">
            <template v-slot:comment>
                <div class="text-body-1 text-center pt-2 pb-4">
                    Doplnit kontakt na VZ (v případě, že není v seznamu)
                </div>
            </template>
        </contact-form>
    </v-card>
</template>

<script>

import {RESOLVER_CONTACT_TYPE_ID} from "@/store/modules/event/contacts";
import {mapGetters} from "vuex";
import ContactForm from "./ContactForm";
import SetRoleFormItem from "@/components/panel/sidebar/event/SetRoleFormItem.vue";

export default {
    name: 'set-role-form',
    components: {
        SetRoleFormItem,
        ContactForm,
    },
    mounted() {
        this.contact.contactTypeId = this.RESOLVER_CONTACT_TYPE_ID;
    },
    data() {
        return {
            RESOLVER_CONTACT_TYPE_ID,
            loading: false,
            isConfirmModal: false,
            form: {
                name: null
            },
            contact: {
                id: null,
                contactTypeId: null,
                contactTypeName: null,
                deviceId: null,
                prefix: null,
                title: "Velitel zásahu",
                name: null,
                suffix: null,
                number: null,
                code: null,
                type: null,
                icon: null,
                custom: 1,
                persistent: 0,
            }
        }
    },
    props: {
        eventId: [Number, null],
    },
    computed: {
      ...mapGetters('eventContacts', {
        contactsByEventKey: 'getByEvent',
      }),
        ...mapGetters('events', {
            getEventById: 'byId',
            getIsHzsEvent: 'isHzsEvent',
        }),
        contacts() {
          return this.contactsByEventKey(this.event.uuid);
        },
        isHzsEvent() {
            return this.getIsHzsEvent(this.event.eventCategoryId);
        },
        event() {
            return this.getEventById(this.eventId);
        },
    },
    methods: {
        setAsResolver(contact, form) {
            this.loading = true;
            contact.contactTypeId = this.RESOLVER_CONTACT_TYPE_ID;
            contact.title = 'Velitel zásahu';
            contact.name = form.name;
            this.$store.dispatch('eventContacts/save', contact).then(() => {
                this.close();
                this.loading = false;
            });
        },
        unsetResolver(contact) {
            this.loading = true;
            if (this.deviceId) {
                contact.contactTypeId = 5;
            } else {
                contact.contactTypeId = 4;
            }
            contact.title = null;
            this.$store.dispatch('eventContacts/save', contact).then(() => {
                this.loading = false;
            });
        },
        close() {
            this.$emit('onClose');
        },
    }
}
</script>
